export default function (t) {
  return [
    { title: t('general.description'), field: 'description' },
    { title: t('general.link'), field: 'link' },
  ];
}
